import React from 'react'
import PropTypes from 'prop-types'

import BaseComponent from 'utils/BaseComponent'

import './styles.scss'

export default class InputFile extends BaseComponent {

  constructor(props) {
    super(props)

    this._bind('_handleClick')
  }

  _handleClick(e) {
    e.preventDefault()
    this.input.click()
  }

  _renderLabel(id) {
    return !!this.props.label ? (
      <label htmlFor={id} className={`label-field-${this.props.labelType}`}>
        {this.props.label}
      </label>
    ) : null
  }

  render() {
    const {labelType, file, errors, ...inputProps} = this.props
    const message = !!this.props.file ? this.props.file.name : 'No se ha seleccionado archivo'
    const actionText = !!this.props.file ? 'Cambiar' : 'Escoger'
    const id = `id_${this.props.name}`
    const errorClass = errors.length ? 'has-errors' : ''

    return (
      <div className="InputFile">
        { this._renderLabel(id) }
        <div className={`InputFile__container modal-elements d-flex justify-content-left align-items-center ${errorClass}`}>
          <button onClick={this._handleClick} className="InputFile__button">{`${actionText} Archivo`}</button>
          <span onClick={this._handleClick}>{message}</span>
          <input
            {...inputProps}
            id={id}
            ref={input => this.input = input}
            type="file"
          />
        </div>
      </div>
    )
  }
}

InputFile.defaultProps = {
  errors: [],
  file: null,
  labelType: 'bold',
}

InputFile.propTypes = {
  errors: PropTypes.array,
  file: PropTypes.object,
  label: PropTypes.string,
  labelType: PropTypes.oneOf(['bold', 'light']),
  name: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/InputFile/index.js